var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Contacts",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,8 C5.33333333,10.5773288 7.42267117,12.6666667 10,12.6666667 C12.5773288,12.6666667 14.6666667,10.5773288 14.6666667,8 C14.6666667,5.42267117 12.5773288,3.33333333 10,3.33333333 C7.42267117,3.33333333 5.33333333,5.42267117 5.33333333,8 L5.33333333,8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1448889,17.8897778 C14.5187092,16.2533858 12.3069979,15.333207 10,15.333207 C7.69300212,15.333207 5.48129083,16.2533858 3.85511111,17.8897778",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.402611be7536cd4d8ed8281d47e8ca6b.svg";
export { ForwardRef as ReactComponent };